var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-btn',{attrs:{"href":"/assets/documents/beszamolo_2017.pdf","target":"_blank"}},[_vm._v(" Pdf ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }